<template>
  <div class="category-list">
    <van-radio-group v-model="radio" @change="rajs">
      <div v-for="(item, index) in searchData" :key="index" class="product">
        <div style="overflow: auto;display: flex;scrollbar-width: none;">
          <div>
            <van-radio :name="index">
              <div class="items-list">
                <div class="items-list-left" @click="goDetails(item.tradeList[0])">
                  <van-image :src="item.commodityImage ? item.commodityImage : simpleImg" class="items-img"
                             fit="contain"></van-image>
                </div>
                <div class="items-list-right">
                  <h4>{{ item.commodityName }}</h4>
                  <p class="items-list-right-text">挂牌ID：{{ item.tradeNo }}</p>
                  <p class="items-list-right-text">销售组织：{{ item.sellerEnterpriseNamee }}</p>
                  <p class="items-list-right-text">仓库：{{ item.warehouseName }}</p>
                </div>
              </div>
            </van-radio>
            <div class="divider"></div>
          </div>
          <div class="deleteBox" @click="delCartItem(item.id)">
            <div>
              <img alt="" class="img2" src="@/assets/imgs/match/删除@2x.png">
              <span>删除</span>
            </div>
          </div>
        </div>
        <div class="item-title">
          <div class="pice">
            <div>含税单价 (元/吨)</div>
            <div class="pice-item">¥ <span>{{ item.price ? item.price : '0' }}</span></div>
          </div>
          <div class="stepper">
            <van-stepper v-model="item.quantity" :value="1" button-size="30" integer/>
            <span>吨</span>
          </div>
        </div>
      </div>
    </van-radio-group>
  </div>
</template>

<script>
export default {
  name: "ProductList",
  data() {
    return {
      querrquantity: "1",
      radio: '1',
      activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      simpleImg: require("assets/imgs/img-null.aea86027.jpg"),
      productType: {
        public: "公开",
        group: "共享",
        private: "专属",
      },
    }
  },
  props: {
    searchData: Array,
  },
  computed: {
    directModeName() {
      let directModeName;
      switch (this.searchData.tradeList.directMode) {
        case "public":
          directModeName = "公开";
          break;
        case "group":
          directModeName = "共享";
          break;
        case "private":
          directModeName = "专属";
          break;
      }
      return directModeName;
    },
  },
  methods: {
    goDetails(it) {
      let id = it.id, directMode = it.directMode;
      this.$router.push("/planSaleDetails?id=" + id + '&directMode=' + directMode);
    },
    rajs(i) {

      this.$emit("rajs", this.searchData[i])
    },
    delCartItem(id) {
      this.$emit("delCartItem", id)

    },
  }
}
</script>

<style lang="stylus" scoped>
.category-list {
  font-size: 26px;

  .product {
    border-radius: 16px;
    background-color: #fff;
    padding: 32px 32px 32px 28px;
    margin-bottom: 32px;
    width: 100%;
    box-sizing: border-box;

    >>> .van-radio__label {
      width: 100%;
      margin: 0;
      padding-left: 24px;
    }

    .items-list {
      display: flex;
      box-sizing: border-box;
      width: 100%;

      .items-list-left {
        margin: 0 24px 0 0;

        .items-img {
          width: 176px;
          height: 176px;
        }
      }

      .items-list-right {
        line-height: none;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-top: 14px;
        width: 370px;

        h4 {
          max-height: 88px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 800;
          font-size: 28px;
          color: #333333;
          line-height: 44px;
          font-style: normal;
          text-transform: none;
          margin-bottom: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .items-list-right-text {
          height: 34px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #666666;
          line-height: 28px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 8px;
        }
      }
    }

    .item-title {
      height 100px
      padding: 20px 0 0 56px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      .pice {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        line-height: 24px;

        .pice-item {
          margin-top: 32px;
          color: #FF5500;
          font-size: 24px;

          span {
            font-size: 40px;
          }
        }
      }

      .stepper{
        width 272px
        height 64px
        display: flex;
        align-items: center

        span{
          margin-left 16px
        }

        >>> .van-stepper{
          height 64px
          display: flex;
          align-items: center
          background: #F5F5F5;
          border-radius: 4px 4px 4px 4px;

          .van-stepper__input {
            height 40px !important
            font-weight: 500;
            font-size: 28px;
            width: 100px;
            border-left: 4px solid #D8D8D8;
            border-right: 4px solid #D8D8D8;
            background unset !important
          }
          button{
            height 40px !important
            background unset !important
          }
        }
      }
    }

    .deleteBox {
      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 128px;
        height: 100%;
        background: #E0000C;

        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 0.28rem;
          color: #fff;
          margin-top: 0.12rem;
        }

      }
    }

    .divider {
      height: 2px;
      background: #EEEEEE;
      border-radius: 16px 16px 16px 16px;
      margin: 32px 0 0px 56px;
    }
  }
}

/deep/ .van-radio__icon {
  font-size: 32px;
}
</style>